var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.0001C17 12.8285 17.6716 13.5001 18.5 13.5001C19.3284 13.5001 20 12.8285 20 12.0001C20 11.1717 19.3284 10.5001 18.5 10.5001C17.6716 10.5001 17 11.1717 17 12.0001ZM10.5 12.0001C10.5 12.8285 11.1716 13.5001 12 13.5001C12.8284 13.5001 13.5 12.8285 13.5 12.0001C13.5 11.1717 12.8284 10.5001 12 10.5001C11.1716 10.5001 10.5 11.1717 10.5 12.0001ZM5.5 13.5001C4.67157 13.5001 4 12.8285 4 12.0001C4 11.1717 4.67157 10.5001 5.5 10.5001C6.32843 10.5001 7 11.1717 7 12.0001C7 12.8285 6.32843 13.5001 5.5 13.5001Z",
    fill: "#081B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/More.8590a063a8fb825c96a02c1d860185c2.svg";
export { ForwardRef as ReactComponent };